import React, { useEffect, useState } from "react";
import Footer from '../../components/footer';
import { useMoralis } from "react-moralis";
import { configs } from '../../../configs/web3.config';
import axios from 'axios';
import UserIdenticon from "../../commons/UserIdenticon";
import { getEllipsisTxt, getSliceLongTxt } from "../../../helpers/formatters"
import { toast } from 'react-toastify'
import { Link } from '@reach/router';
import { getFileTypeFromURI } from '../../../helpers/fileTypeDecoder'
import Select from 'react-select'
import { DateTime } from "luxon";

const customStyles = {
  option: (base, state) => ({
    ...base,
    background: "#212428",
    color: "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    "&:hover": {
      background: "#16181b",
    }
  }),
  menu: base => ({
    ...base,
    background: "#212428 !important",
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0
  }),
  control: (base, state) => ({
    ...base,
    padding: 2
  })
};

const status = [
  { value: '-1', label: 'Select status' },
  { value: 'pending', label: 'Pending' },
  { value: 'active', label: 'Active' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'on-hold', label: 'On Hold' }
]

const ModerateNFT = function ({ contractAddress, tokenId, itemId }) {


  const { Moralis, isInitialized } = useMoralis()
  const { web3Config } = configs

  // const [isProfileDataLoading, setIsProfileDataLoading] = useState(false)
  const [isNFTDataLoading, setIsNFTDataLoading] = useState(false)
  // const [nftOwnerData, setNftOwnerData] = useState({})
  const [nftMetaData, setNftMetaData] = useState({})
  const [nftImage, setNftImage] = useState('')
  const [nftTitle, setNftTitle] = useState('~')
  const [nftDescription, setNftDescription] = useState('~')
  const [nftMarketPlaceData, setNftMarketPlaceData] = useState(null)
  const [isNftMarketplaceDataLoading, setIsNftMarketplaceDataLoading] = useState(false)

  const [nftOwnerData, setNftOwnerData] = useState({})
  const [isProfileDataLoading, setIsProfileDataLoading] = useState(false)
  const [nftContentType, setNftContentType] = useState('')
  const [nftStatus, setNftStatus] = useState('')
  const [isNFTStatusUpdateLoading, setIsNFTStatusUpdateLoading] = useState(false)

  const getNFTPrice = (price) => {
    if (price) {
      const priceData = parseInt(price)
      const actualPrice = priceData / (10 ** 18)
      return actualPrice
    } else {
      return 0.0
    }
  }

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 60)
      } else {
        return getEllipsisTxt(moralisAttributes.walletAddress, 7)
      }
    } else {
      return getEllipsisTxt(nftMetaData ? nftMetaData.owner_of : '', 7)
    }
  }

  useEffect(() => {
    if (nftMarketPlaceData && nftMarketPlaceData.attributes) {
      setNftStatus(nftMarketPlaceData.attributes.status || 'pending')
    } else {
      setNftStatus('pending')
    }
  }, [nftMarketPlaceData])


  const getTokenCreatorProfile = async (walletAddress) => {
    try {
      setIsProfileDataLoading(true)
      const params = { walletAddress };
      const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
      setNftOwnerData(profileDataResponse)
      setIsProfileDataLoading(false)
    } catch (error) {
      setIsProfileDataLoading(false)
      console.error("MORALIS ERROR while fetching profile data ", error)
    }
  }

  const getTokenDetailsFormMarketPlace = async () => {
    try {
      setIsNftMarketplaceDataLoading(true)
      const params = { nftContract: contractAddress, itemId: itemId };
      const nftMarketplaceDataResponse = await Moralis.Cloud.run("getMarketPlaceNFTItem", params);
      setNftMarketPlaceData(nftMarketplaceDataResponse)
      setIsNftMarketplaceDataLoading(false)
    } catch (error) {
      setIsNftMarketplaceDataLoading(false)
      console.error("MORALIS ERROR while fetching nft marketplace data ", error)
    }
  }

  const getNFTMetaData = async () => {
    try {
      setIsNFTDataLoading(true)
      const options = { address: contractAddress, token_id: tokenId, chain: web3Config.moralisChainId };
      const tokenIdMetadataResponse = await Moralis.Web3API.token.getTokenIdMetadata(options);
      setNftMetaData(tokenIdMetadataResponse)
      setIsNFTDataLoading(false)
    } catch (error) {
      setIsNFTDataLoading(false)
      setNftMetaData({})
      console.error("MORALIS ERROR while fetching NFT metadata ", error)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        await getTokenCreatorProfile(nftMetaData.owner_of)
      }
    } catch (error) {
      console.error("MORALIS ERROR error while fetching nft owner data ", error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftMetaData, isInitialized])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        await getNFTMetaData()
        await getTokenDetailsFormMarketPlace()
      }
    } catch (error) {
      console.error("MORALIS ERROR error while fetching your NFTS ", error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractAddress, tokenId, isInitialized])


  const handleNFTStatusUpdate = async () => {
    try {
      if (isInitialized && nftMarketPlaceData) {
        setIsNFTStatusUpdateLoading(true)
        //find the marketplace object  by id
        const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
        const query = new Moralis.Query(CreatedMarketplaceItems)
        query.equalTo('objectId', nftMarketPlaceData.id)
        const result = await query.find()
        if (result && result.length > 0) {
          const nftItem = result[0]
          nftItem.set('status', nftStatus)
          await nftItem.save()
        }
        setIsNFTStatusUpdateLoading(false)
        toast.dark('NFT status has been updated', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setIsNFTStatusUpdateLoading(false)
      toast.dark('Something went wrong while updating the profile status', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("ERROR : something went wrong while updating the NFT status ", error)
    }
  }


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (nftMetaData.metadata) {
      const metadata = JSON.parse(nftMetaData.metadata)
      let processedImageUrl = ''
      if (metadata.image && metadata.image.includes('ipfs://')) {
        const imageUrl = metadata.image.split('ipfs://')
        processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
      } else {
        processedImageUrl = metadata.image
      }

      // get the file content type 
      const contentType = await getFileTypeFromURI(processedImageUrl)
      setNftContentType(contentType || '')
      setNftImage(processedImageUrl)
      setNftTitle(metadata.name || '~')
      setNftDescription(metadata.description || '~')
    } else {
      if (nftMetaData.token_uri) {
        const response = await axios.get(nftMetaData.token_uri)
        if (response.status === 200) {
          const metadata = response.data
          let processedImageUrl = ''
          if (metadata.image && metadata.image.includes('ipfs://')) {
            const imageUrl = metadata.image.split('ipfs://')
            processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
          } else {
            processedImageUrl = metadata.image
          }

          // get the file content type 
          const contentType = await getFileTypeFromURI(processedImageUrl)
          setNftContentType(contentType || '')
          setNftImage(processedImageUrl)
          setNftTitle(metadata.name || '~')
          setNftDescription(metadata.description || '~')
        }
      } else {
        setNftImage('')
        setNftTitle('~')
        setNftDescription('~')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftMetaData])



  const handleStatusSelect = (selectedStatus) => {
    if (selectedStatus) {
      setNftStatus(selectedStatus.value)
    }
  }

  return (
    <div>
      <section className='container'>

        {
          isNFTDataLoading || isNftMarketplaceDataLoading ?
            (
              <div className='row mt-md-5 pt-md-4'>
                <div className='col-lg-12'>
                  <div className='loading-container'>
                    <div className="spinner-grow" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>
            ) :
            (
              <div className='row mt-md-5 pt-md-4'>

                <div className="col-md-6 text-center detail-view-main-image">
                  {
                    nftContentType.includes('audio') ? (
                      <div>
                        <audio controls>
                          <source src={nftImage} type={nftContentType} />
                        </audio>
                      </div>
                    ) : (<></>)
                  }

                  {
                    nftContentType.includes('image') ? (
                      <img src={nftImage} alt={nftTitle} className="img-fluid img-rounded mb-sm-30" />
                    ) : (<></>)
                  }
                </div>
                <div className="col-md-6">
                  <div className="item_info">
                    Token Created At
                    <div className="de_countdown">
                      {nftMetaData ? DateTime.fromISO(nftMetaData.synced_at).toFormat('ff') : ''}
                    </div>
                    <h2>{nftTitle}</h2>
                    <span className="nft-selling-price">
                      {getNFTPrice(nftMarketPlaceData ? nftMarketPlaceData.attributes.price : 0.0)} BNB
                    </span>
                    <div className="item_info_counts mt-3">
                      <div className="item_info_type"><i className="fa fa-image"></i>{nftMetaData.contract_type}</div>
                      <div className="item_info_views"><i className="fa fa-eye"></i>Token ID # {nftMetaData.token_id}</div>
                      <div className="item_info_like"><i className="fa fa-heart"></i>Token Symbol : {nftMetaData.symbol}</div>
                    </div>
                    <p>{nftDescription}</p>

                    <h6>Current Owner</h6>
                    <div className="item_author">
                      <div className="author_list_pp">
                        <span>
                          <UserIdenticon size="50" walletAddress={nftMetaData.owner_of} customCss={{ width: '50px', height: '50px' }} />
                          <i className="fa fa-check"></i>
                        </span>
                      </div>

                      <div className="author_list_info">

                        {
                          isProfileDataLoading ?
                            (
                              <span>
                                <div className="spinner-grow spinner-grow-sm" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                              </span>
                            ) :
                            (
                              <span>
                                {getUsername(nftOwnerData ? nftOwnerData.attributes : null)}
                              </span>
                            )
                        }
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt-5">
                      <div className='dropdownSelect one'>
                        <Select className='select1'
                          styles={customStyles}
                          menuContainerStyle={{ 'zIndex': 999 }}
                          value={
                            status.filter(option =>
                              option.value === nftStatus)
                          }
                          defaultValue={status[0]} options={status}
                          onChange={handleStatusSelect} />
                      </div>
                    </div>

                    <div className="spacer-40"></div>

                    <div className="de_tab">
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="list-nft-btn sell-nft-btn" onClick={handleNFTStatusUpdate}>
                            {
                              !isNFTStatusUpdateLoading ? (
                                <div className="btn-rounded">
                                  Update
                                </div>
                              ) : (
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='loading-container'>
                                      <div className="spinner-grow" role="status">
                                        <span className="sr-only">Loading...</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            )

        }

      </section>

      <Footer />
    </div>
  );
}
export default ModerateNFT;